import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { Icon } from "../../components/Icon";
import { PageHead } from "../../components/ui";
import { showCommandPalette } from "../../components/shell/CommandPalette";
import { TarifKarte, useTarifKurzstand } from "../../components/Tarif";
import { AGENCY_SETTINGS, BETRIEB_LINK, CREATOR_AREA_LINK, agencyMore, studioMore } from "../../app/nav";
import { useAccount, useStaffWorkspace } from "../../app/session";
import { api } from "../../data";
import { loadLifecycle } from "./einstellungen/data";
import { t } from "../../lib/sprache";

/**
 * „Mehr“ auf dem Handy (SICHT-AGENTUR-GELD-9): alle Bereiche der Seitenleiste, die in der unteren Leiste keinen Platz
 * haben, mit denselben Rechten gefiltert; dazu Benachrichtigungen, das eigene Profil, der Bereichswechsel bei Doppelrolle
 * und die Suche (Befehlspalette), deren Knopf im Kopf am Handy fehlt. Oben die Tarifkarte für Admins (K-371).
 */
export function AgenturMehr() {
  const ws = useStaffWorkspace();
  const { account } = useAccount();
  const life = useQuery({ queryKey: ["org_lifecycle", ws.org.org_id], queryFn: () => loadLifecycle(api, ws.org.org_id), staleTime: 60_000, enabled: ws.isChef });
  const tarif = useTarifKurzstand(ws, life.data);
  const dual = (account?.talentLinks.length ?? 0) > 0;
  const items = [
    ...(ws.isCreator ? studioMore() : agencyMore(ws.isChef, ws.can("view_financials"), ws.can("trigger_payouts"), ws.can("view_amounts"))),
    { label: t("Benachrichtigungen", "Notifications"), to: "/agentur/benachrichtigungen", icon: "bell" as const },
    { label: ws.isCreator ? t("Mein Zugang", "My access") : t("Mein Profil", "My profile"), to: "/agentur/profil", icon: "users" as const },
    // K-372: Manager erreichen ihre persönlichen Einstellungen (Profil, Anmeldung & Sicherheit) über die Liste
    ...(ws.isChef ? [] : [AGENCY_SETTINGS]),
    ...(dual ? [CREATOR_AREA_LINK] : []),
    // Plattform-Admin: die Betreiber-Konsole auch am Handy (vorher nur in der Seitenleiste am Desktop)
    ...(account?.isPlatformAdmin ? [BETRIEB_LINK] : []),
  ];
  return (
    <main id="main" className="content">
      <PageHead title={t("Mehr", "More")} eyebrow={ws.org.name} />
      <TarifKarte stand={tarif} variante="mehr" timeZone={ws.org.timezone} />
      <nav className="panel stack tk-menu" aria-label={t("Alle Bereiche", "All sections")}>
        {items.map((i) => (
          <Link key={i.to} to={i.to} className="task">
            <span className="row"><Icon name={i.icon} />{i.label}</span>
            <span aria-hidden="true">›</span>
          </Link>
        ))}
      </nav>
      <div className="row">
        <button type="button" onClick={showCommandPalette}><Icon name="search" />{t("Suchen", "Search")}</button>
      </div>
    </main>
  );
}
